<template>
  <div class="col-8">
    <div class="input-wrapper">
      <label class="form-control-label">
        <h4>Redirect URL</h4>
      </label>

      <input
        type="text"
        ref="redirect_url"
        v-model="redirect_url"
        @change="update"
        :disabled="disabled"
        class="form-control"
      />
    </div>
  </div>
</template>

<script>
import { gameService } from "@/api/client";

const httpService = gameService.axiosInstance;

export default {
  props: ["gameConfig"],

  data() {
    return {
      redirect_url: null,
    };
  },

  computed: {
    disabled() {
      return !["draft", "scheduled", "paused"].includes(this.gameConfig.status);
    },
  },

  mounted() {
    this.redirect_url = this.gameConfig.redirect_url;
  },

  methods: {
    async isFormValid() {
      return true;
    },

    async update() {
      try {
        const formValid = await this.isFormValid();
        if (!formValid) return;

        await httpService.put(`/game/${this.gameConfig.id}`, {
          redirect_url: this.redirect_url,
        });

        this.$notify(`Redirect URL updated.`);
        this.$emit("updated");
      } catch (error) {
        error.response
          ? this.$dialogs.alert(error.response.data)
          : this.$dialogs.alert(`Redirect URL update error.`);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form-control-label {
  display: flex;
  justify-content: space-between;

  padding: 0px;

  h4,
  p {
    margin-bottom: 0.5em;
  }
}
</style>
